const isNonNegativeInteger = (value) => /^\d+$/.test(String(value).trim());

const isEmptyValue = (value) =>
  value === null || value === undefined || String(value).trim() === "";

// integersOnly: every writable field has to be empty or a whole number, 0 or greater (same rule as the backend)
const validate = (values, setErrors, integersOnly = false) => {
  if (JSON.stringify(values) === "[]") return false;
  const errorFieldIds = [];

  for (let i = 0; i < values.length; i++) {
    if (
      values[i].accessMode === "write" &&
      values[i].required === true &&
      (!values[i].value || values[i].value?.length === 0)
    ) {
      errorFieldIds.push(values[i].wsMetaFieldUuid);
    } else if (
      integersOnly &&
      values[i].accessMode === "write" &&
      !isEmptyValue(values[i].value) &&
      !isNonNegativeInteger(values[i].value)
    ) {
      errorFieldIds.push(values[i].wsMetaFieldUuid);
    }
  }
  // set errors
  setErrors(errorFieldIds);
  return errorFieldIds.length === 0;
};

const clearValues = (values, setValues, setErrors) => {
  const newVals = values.map((v) => {
    const isArray = Array.isArray(v.value);

    if (isArray) return { ...v, value: v.value.filter((w) => !w?.new) };

    return v.accessMode === "read" ? v : { ...v, value: "" };
  });
  setValues(newVals);
  setErrors([]);
};

const getFormSubmitErrorToastMessages = (errors) => {
  const backendErrors = errors ?? [];
  const hasEditorAccessError = backendErrors.some(
    (backendError) => backendError.field === "editor",
  );
  const otherMessages = [
    ...new Set(
      backendErrors
        .filter((backendError) => backendError.field !== "editor")
        .map((backendError) => backendError.message)
        .filter(Boolean),
    ),
  ];

  return { hasEditorAccessError, otherMessages };
};

export { validate, clearValues, getFormSubmitErrorToastMessages, isEmptyValue };
